import { z } from 'zod';

export const ScenarioRequestSchema = z.object({
    name: z.string(),
    day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to_compare_only: z.boolean().catch(false),
    selected: z.boolean().optional(),
    collection_id: z.number(),
    tactical_plan_id: z.number().nullable().catch(null),
    planning_started: z.string().nullable().catch(null), // FIXME: expected date or timestamp
    ignore_defined_order: z.boolean().optional()
});
export type ScenarioRequestType = z.infer<typeof ScenarioRequestSchema>;

export const ScenarioResponseSchema = ScenarioRequestSchema.merge(
    z.object({
        id: z.number(),
        created: z.string(),
        updated: z.string(),
        revision: z.string().catch(''),
    })
);
export type ScenarioResponseType = z.infer<typeof ScenarioResponseSchema>;
